// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__5lV5A","avatarClass":"styles_avatarClass__fwOuO","name":"styles_name__kmCzy","role":"styles_role__NFhrf"};